import { render, staticRenderFns } from "./SignRecordList.vue?vue&type=template&id=53d89a44&"
import script from "./SignRecordList.vue?vue&type=script&lang=js&"
export * from "./SignRecordList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports